import React from 'react';
import Modal from 'react-modal';
import { useAtom, PrimitiveAtom } from 'jotai';
import CloseIcon from '@/assets/close.svg?react';
import { customStyles } from '@/assets/Const';
import { ModalOpenFlg } from '@/utility/CommonAtoms';

type Props = {
  children: React.ReactNode;
  modalOpenAtom: PrimitiveAtom<boolean>;
  modalClass: string;
  disabledClose?: boolean;
  backgroundModalClose?: boolean;
  closeEvent?: () => void;
};

export const ModalBase = (props: Props) => {
  const [isOpen, setIsOpen] = useAtom(props.modalOpenAtom);

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      ariaHideApp={false}
      onRequestClose={() => setIsOpen(props?.backgroundModalClose ? props.backgroundModalClose : false)}
    >
      <div className={props.modalClass + ' md:w-2grid w-grid-sp  p-[30px] mx-auto'}>
        <div className="w-full text-center relative">
          <div className="relative w-full text-right z-[5] top-[-18px] right-[-18px]">
            {(props.disabledClose === undefined || !props.disabledClose) && (
              <button
                onClick={() => {
                  setIsOpen(false);
                  if (props.closeEvent) {
                    props.closeEvent();
                  }
                }}
                type="button"
                className="cancel"
              >
                <CloseIcon width={30} height={30} className="bg-main rounded-full fill-contents" />
              </button>
            )}
          </div>
          {props.children}
        </div>
      </div>
    </Modal>
  );
};

export const ModalBaseWithFlg = (
  props: Omit<Props, 'modalOpenAtom' | 'backgroundModalClose'> & {
    modalOpenAtom: PrimitiveAtom<ModalOpenFlg>;
    backgroundModalClose: ModalOpenFlg;
  }
) => {
  const [isOpen, setIsOpen] = useAtom(props.modalOpenAtom);

  return (
    <Modal
      isOpen={isOpen !== 'CLOSE'}
      style={customStyles}
      ariaHideApp={false}
      onRequestClose={() => setIsOpen(props?.backgroundModalClose ? props.backgroundModalClose : 'CLOSE')}
    >
      <div className={props.modalClass + ' md:w-2grid w-grid-sp  p-[30px] mx-auto'}>
        <div className="w-full text-center relative">
          <div className="relative w-full text-right z-[5] top-[-18px] right-[-18px]">
            {(props.disabledClose === undefined || !props.disabledClose) && (
              <button
                onClick={() => {
                  setIsOpen('CLOSE');
                  if (props.closeEvent) {
                    props.closeEvent();
                  }
                }}
                type="button"
                className="cancel"
              >
                <CloseIcon width={30} height={30} className="bg-main rounded-full fill-contents" />
              </button>
            )}
          </div>
          {props.children}
        </div>
      </div>
    </Modal>
  );
};
